<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { showToast } from '../lib/toast';
  import { isMatchDateTodayOrLater, isMatchFinished } from '../lib/utils/reportUtils';
  import { deleteMatch, trackEvent } from '../lib/apiService';
  import { _ } from 'svelte-i18n';
  import type { SessionInfo } from '../types';
  import ConfirmationModal from './ConfirmationModal.svelte';
  import { onMount } from 'svelte';
  import { formatDate, formatTime } from '../lib/utils/reportUtils';

  export let report;
  export let onDelete = null;
  export let sessionInfo: SessionInfo;

  // Compute the match result
  $: result = report.score_team > report.score_opponent 
    ? $_('reportCard.result.win')
    : report.score_team < report.score_opponent 
      ? $_('reportCard.result.lost')
      : $_('reportCard.result.draw');


  // Compute the badge color  
  const match_result = report.score_team > report.score_opponent 
    ? 'Win'
    : report.score_team < report.score_opponent 
      ? 'Lost'
      : 'Draw';
  $: badgeColor = match_result === 'Win' 
    ? 'var(--color-success, #22c55e)' 
    : match_result === 'Lost' 
      ? '#ef4444' 
      : '#64748b';

  let showDeleteConfirmation = false;

  function handleDelete() {
    showDeleteConfirmation = true;
  }

  async function confirmDelete() {
    showDeleteConfirmation = false;
    try {
      await deleteMatch(report.id, (result, status) => {
        if (status === 200) {
          showToast($_('reportCard.deleteSuccess'), 'success');
          if (onDelete) onDelete(report.id);
          trackEvent('delete_match', {
            module: "matches",
            action_type: "delete_data",
            description: 'Delete a match',
          }, sessionInfo.user.id);
        } else {
          showToast($_('reportCard.deleteError'), 'error');
        }
      });
    } catch (error) {
      console.error('Error deleting report:', error);
      showToast($_('reportCard.deleteError'), 'error');
    }
  }


  onMount(async () => {
  });
</script>

<button 
  class="my-0 clickable article_button" 
  on:click={() => push(`/match/${report.id}/details`)}>
  <article>
    <header class="flex space-between">
      <div>
        <h4 class="mb-0">{report.opponent_club?.name}</h4>
        <span class="date">{formatDate(report.match_date)} <ion-icon name="time-outline"></ion-icon> {formatTime(report.match_date)}</span>
      </div>
      <div class="text text-sm">
        {report.location === 'home' ? $_('reportCard.location.home') : $_('reportCard.location.away')}
      </div>
    </header>

    <!-- Card content -->
    <div class:away-game={report.location.toLowerCase() === 'away'} class="score-container">
      <div class="score">
        <span class="team"><img src={`/img/clublogos/${sessionInfo.active_team.club.logo_filename}?${import.meta.env.VITE_CACHE_VERSION}`} alt="{sessionInfo.active_team.club.name}" class="team-logo"><br/>{sessionInfo.active_team.name}</span>
        {#if isMatchDateTodayOrLater(report.match_date)}
          <div class="score-number flex flex-col text text-lg text-bold text-center">
            <div>{report.location.toLowerCase() === 'away' ? report.score_opponent : report.score_team} - 
            {report.location.toLowerCase() === 'away' ? report.score_team : report.score_opponent}</div>   
            {#if isMatchFinished(report.match_date)}
            <div class="result-badge" style="background-color: {badgeColor}">
                {result}
              </div>
            {/if}
          </div>
        {/if}
        <span class="team"><img src={`/img/clublogos/${report.opponent_club.logo_filename}?${import.meta.env.VITE_CACHE_VERSION}`} alt="{report.opponent_club.name}" class="team-logo"><br/>{report.opponent_team_name}</span>
      </div>
      
    </div>

    <footer class="flex justify-end">
        <hr class="my-6"/>
        <button class="secondary outline ghost small" title={$_('reportCard.actions.delete')} on:click|stopPropagation={handleDelete}>
          <ion-icon name="trash-outline"></ion-icon>
        </button>
    </footer>
  </article>
</button>

<ConfirmationModal 
  isOpen={showDeleteConfirmation}
  title={$_('reportCard.deleteTitle')}
  message={$_('reportCard.confirmDelete')}
  onConfirm={confirmDelete}
  onCancel={() => showDeleteConfirmation = false}
/>

<style>
  .date {
    font-size: 0.9rem;
  }

  .score-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .score {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
  }

  .away-game .score {
    flex-direction: row-reverse;
  }

  .team {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    text-align: center;
  }

  .score-number {
    white-space: nowrap;
  }

  .result-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    color: white;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0.2rem auto;
  }

</style> 